import React, {useState} from 'react';
import Title from '../title-tile/titleTileComponent';

const DeliveryDate = (props) => {
    const [error, setError] = useState(null);
    const DAYS_ORDER = 1;

    const setDate = (e) => {
        const date = e.target.value;
        let minDate = new Date();
        minDate.setDate(minDate.getDate() + (DAYS_ORDER - 1));
        const deliveryDate = new Date(date);

        // Check if weekend show error
        if (deliveryDate.getDay() === 5 || deliveryDate.getDay() === 6){
            setError(`La fecha seleccionada no es un dia habil.`);
            return;
        }

        if (date && minDate < deliveryDate) {
            // Use UTC noon to prevent timezone offset from rolling the date back a day
        props.setDeliveryDate(new Date(date + 'T12:00:00.000Z').toISOString());
            setError(null);
            props.setHasErrors({ date: false });
        } else {
            setError(`La fecha tiene que estar seleccionada y ser ${DAYS_ORDER} dias mayor a hoy.`);
            props.setHasErrors({ date: true });
        }
    };

    return (
        <div className="order-details-section">
            <Title
                hide={false}
                message='Fecha de Entrega'
                alignLeft={true}
            />
            <div className="order-details-form-group">
                <div className="order-details-input-wrapper">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Fecha:</span>
                        </div>
                        <input
                            type="date"
                            className="form-control"
                            onChange={setDate}
                            onBlur={setDate}
                        />
                    </div>
                </div>
            </div>
            {error && <p className="details-error">{error}</p>}
        </div>
    );
};

export default DeliveryDate;
